import {
  createCurrencyFormatter,
  CurrencyFormatter,
} from 'src/localization/currencyFormatter'
import { getLocaleInfo } from 'src/localization/locales'
import { useNullSafeLocale } from 'src/localization/useNullSafeLocale'

export const useCurrencyFormatter = (): CurrencyFormatter => {
  const locale = useNullSafeLocale()
  const defaultDisplayCurrency = getLocaleInfo(locale).currency

  return createCurrencyFormatter(locale, defaultDisplayCurrency)
}
